import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import LoginSuccess from './pages/LoginSuccess';
import { ToastProvider } from "./components/Toast.js";
import ProtectedRoute from "./components/ProtectedRoute.js";
import { useEffect } from 'react';

function App() {

  useEffect(() => {
  function handleStorageChange(e) {
    if (e.key === "authToken") {
      if (!e.newValue) {
        window.location.href = "/";  
      }
    }
  }

  window.addEventListener("storage", handleStorageChange);
  
  return () => window.removeEventListener("storage", handleStorageChange);
}, []);


  return (
    <ToastProvider>
      <Router>
        <Routes>

          {/* Public routes */}
          <Route path="/" element={<Login />} />
          <Route path="/login/success" element={<LoginSuccess />} />

          {/* Redirect /dashboard → /dashboard/home BEFORE wildcard */}
          <Route
            path="/dashboard"
            element={<Navigate to="/dashboard/home" replace />}
          />

          {/* Protected dashboard routes */}
          <Route 
            path="/dashboard/*" 
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } 
          />

        </Routes>
      </Router>
    </ToastProvider>
  );
}

export default App;



// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';
// import LoginSuccess from './pages/LoginSuccess';
// import { ToastProvider } from "./components/Toast.js";
// import ProtectedRoute from "./components/ProtectedRoute.js";

// function App() {
//   return (
//     <ToastProvider>
//       <Router>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/login/success" element={<LoginSuccess />} />
//         <Route path="/dashboard/*" element={ <ProtectedRoute><Dashboard /></ProtectedRoute>} />
//         <Route path="/dashboard" element={<Navigate to="/dashboard/deploy" replace />} />
//       </Routes>
//     </Router>
//     </ToastProvider>
    
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';
// import LoginSuccess from './pages/LoginSuccess'; // 👈 new component for Google OAuth redirect

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* 🔑 Login routes */}
//         <Route path="/" element={<Login />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/login/success" element={<LoginSuccess />} /> {/* 👈 Google callback */}

//         {/* 🚀 Dashboard routes */}
//         <Route path="/dashboard/*" element={<Dashboard />} />
//         <Route
//           path="/dashboard"
//           element={<Navigate to="/dashboard/deploy" replace />}
//         />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/dashboard/*" element={<Dashboard />} />
//         {/* redirect /dashboard → /dashboard/deploy */}
//         <Route path="/dashboard" element={<Navigate to="/dashboard/deploy" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;



// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Login from './pages/Login';
// import Dashboard from './pages/Dashboard';
// import ClusterList from './pages/ClusterList';
// import DeleteCluster from './pages/DeleteCluster';

// function App() {
//   return (
//     <Router>
//       <Routes>
//         <Route path="/" element={<Login />} />
//         <Route path="/dashboard/*" element={<Dashboard />} />
//         {/* <Route path="/clusters" element={<ClusterList />} />
//         <Route path="/delete-cluster" element={<DeleteCluster />} /> */}
//       </Routes>
//     </Router>
//   );
// }

// export default App;
